import { camelToSnake } from "../../utils/camelSnakeTransformation";
import { deepTransformKeys } from "../../utils/transformObjectKeys";

const appendValue = (searchParams, key, value) => {
  if (Array.isArray(value)) {
    if (value.length > 0) {
      const listValue = value.join(",");
      searchParams.append(key, listValue);
    }
  } else {
    searchParams.append(key, value);
  }
};

/**
 *
 * @param {Object} params
 * @param {Array<string>} exclude
 * @returns
 */
export const constructSearchParams = (params, exclude = []) => {
  const searchParams = new URLSearchParams();

  if (!params) return searchParams;

  const nonEmptyParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== null && value !== undefined
    )
  );

  if (Object.keys(nonEmptyParams).length === 0) return searchParams;

  // make keys snake_case
  const snakeCaseParams = deepTransformKeys(
    nonEmptyParams,
    camelToSnake,
    exclude
  );

  // populate the URLSearchParams object
  for (const [key, value] of Object.entries(snakeCaseParams)) {
    appendValue(searchParams, key, value);
  }

  return searchParams;
};
